import MenuItem from "@material-ui/core/MenuItem";
import InputBase from "@material-ui/core/InputBase";
import InputLabel from "@material-ui/core/InputLabel";
import {Theme, withStyles, createStyles, styled} from '@material-ui/core/styles';
import Button from "@material-ui/core/Button";

interface Props {
    height?: number,
    width?: number,
    fontSize?: number,
    border?: string,
    labelmargin?: number,
    fontWeight?: number
}
export const MyInput = withStyles((theme: Theme) =>
    createStyles({
        root: {
            'label + &': {
                marginTop: (props:Props) => props.labelmargin ? props.labelmargin : theme.spacing(3),
            },
        },
        input:  {
            borderRadius: 2,
            height: (props: Props) => props.height ? props.height : '',
            width: (props: Props) => props.width ? props.width : '',
            position: 'relative',
            backgroundColor: theme.palette.background.paper,
            textAlign: 'left',
            fontSize: (props: Props) => props.fontSize ? props.fontSize : 12,
            padding: '8px 20px 8px 10px',
            border: (props: Props) => props.border ? 'none' : '1px solid #ced4da',
            transition: theme.transitions.create(['border-color', 'box-shadow']),
            color: '#1D3155',
            fontWeight: (props: Props) => props.fontWeight ? props.fontWeight : 400,
            '&:focus': {
                borderRadius: 2,
                borderColor: '#80bdff',
                boxShadow: '0 0 0 0.2rem rgba(0,123,255,.25)',
            },
            '&.Mui-disabled':{
                background: '#dedada',
                color: '#676767'
            }
        },
    })
)(InputBase);

export const Label = withStyles((theme: Theme) =>
    createStyles({
        root: {
            fontSize: (props: Props) => props.fontSize ? props.fontSize : 16,
            color: '#7F899C',
            // fontWeight: 600,
            '&.Mui-focused':{
                color: '#1D3155',
            }
        }
    }),
)(InputLabel);


export const MyMenuItem = styled(MenuItem)({
    minHeight: 0
})


export const PrimaryButton = withStyles((theme: Theme) =>
    createStyles({
        root: {
            backgroundColor: '#0C7CFF',
            color: '#fff',
            '&:hover': {
                backgroundColor: '#0b71e1',
            }
        },
        disabled: {
            backgroundColor: '#fff',
            border: '1px solid #ccc'
        }
    })
)(Button)

export const WhiteButton = withStyles((theme: Theme) =>
    createStyles({
        root: {
            backgroundColor: '#fff',
            color: '#1D3155',
            border: '1px solid #CDD3DC',
            marginRight: theme.spacing(1),
            '&:hover': {
                borderColor: '#0C7CFF',
                backgroundColor: '#fff'
            }
        }
    })
)(Button)